// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
      padding: theme.spacing(3),
      maxWidth: '520px',
      width: '100%',
    },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  headerIcon: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(1),
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '20px',
    marginBottom: theme.spacing(2),
  },
  successBanner: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#E8F5E9',
    borderRadius: '6px',
    padding: theme.spacing(1, 2),
    marginBottom: theme.spacing(2),
    gap: theme.spacing(1),
  },
  successBannerText: {
    fontSize: '14px',
    color: '#2E7D32',
  },
  errorBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    backgroundColor: '#FF942426',
    border: '1px solid #FF9424',
    borderRadius: '6px',
    padding: theme.spacing(1, 2),
    marginBottom: theme.spacing(2),
    gap: theme.spacing(1),
  },
  errorBannerText: {
    fontSize: '14px',
    color: '#333',
  },
  providerRow: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5, 0),
    borderBottom: '1px solid #E0E0E0',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  providerLogo: {
    width: '40px',
    height: '40px',
    borderRadius: '8px',
    marginRight: theme.spacing(1.5),
    objectFit: 'contain',
  },
  providerName: {
    fontSize: '16px',
    fontWeight: 500,
    flex: 1,
  },
  checkingStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: '#9E9E9E',
    fontSize: '14px',
  },
  headerImage: {
    width: '48px',
    height: '48px',
  },
  successIcon: {
    color: '#4CAF50',
    fontSize: 20,
  },
  warningIcon: {
    color: '#FF9424',
    fontSize: 20,
    mt: '2px',
  },
  proceedButton: {
    display: 'block',
    margin: '24px auto 0',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    borderRadius: '6px',
    padding: theme.spacing(1, 4),
    textTransform: 'uppercase',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: '#0189bd',
    },
  },
});

export default styles;
